import type { RequestWorkflowsData } from '@workflows/types';
import type { WorkflowDataLoadState } from './workflow-data.types';
import type { WorkflowPendingWorkSummary } from './workflow-pending-work.types';
import type { WorkflowScreenState } from './workflow-screen-state.types';

/**
 * Единое состояние экрана регламентов из результата загрузки и очередей заявки
 */
export function computeWorkflowScreenState(
  loadState: WorkflowDataLoadState,
  pendingWork: WorkflowPendingWorkSummary,
): WorkflowScreenState {
  switch (loadState) {
    case 'idle':
    case 'loading':
      return 'loading';
    case 'unauthorized':
    case 'forbidden':
      return 'forbidden';
    case 'not-found':
    case 'disabled':
      return 'not-found';
    case 'unavailable':
      return 'unavailable';
    case 'stale-offline':
      return 'stale-offline';
    case 'live':
      break;
  }

  // Очередь не прочиталась: неотправленные данные могут быть — не показываем «всё отправлено»
  if (pendingWork.unknown || pendingWork.failed > 0) {
    return 'sync-failed';
  }

  if (pendingWork.pending > 0) {
    return 'sync-pending';
  }

  return 'live';
}

/**
 * Данные регламентов относятся к открытой заявке. Поздний результат загрузки/кэша
 * предыдущей заявки (в т.ч. повтор shareReplay при переключении) не применяется.
 */
export function isWorkflowDataForRequest(
  data: RequestWorkflowsData,
  requestNumber: string | undefined,
): boolean {
  const dataRequestNumber = data.requestWorkflowsContext?.requestNumber;

  return !dataRequestNumber || dataRequestNumber === requestNumber;
}
